// Image swiper

let imageSwiperComponent = document.querySelector("[swiper='product-images']");

if (imageSwiperComponent) {
  let imageSwiperElement = imageSwiperComponent.querySelector(".swiper");

  let paginationEl = imageSwiperComponent.querySelector(
    ".product-img_pagination"
  );
  // const thumbsSwiper =
  var isZoomedIn = false; // Track zoom state separately

  // Track zoom state separately
  var isZoomedIn = false;

  var imageSwiper = new Swiper(imageSwiperElement, {
    speed: 600,
    slidesPerGroup: 1,
    slidesPerView: 1,
    spaceBetween: 0,
    thumbs: {
      swiper: new Swiper(".thumbs-swiper", {
        breakpoints: {
          480: {
            direction: "horizontal",
          },
          768: {
            direction: "horizontal",
          },
          1024: {
            direction: "vertical",
          },
        },
        allowTouchMove: true,
        slidesPerView: "auto",
        spaceBetween: 12,
        navigation: {
          nextEl: ".thumbs-swiper-next",
          prevEl: ".thumbs-swiper-prev",
        },
      }),
    },
    loop: true,
    centeredSlides: false,
    allowTouchMove: true, // Enable touch movement globally
    slideActiveClass: "is--active",
    pagination: {
      el: paginationEl,
      bulletClass: "product-img_bullet",
      bulletActiveClass: "is--active",
      bulletElement: "button",
      clickable: true,
    },
    on: {
      init: () => {
        document.dispatchEvent(new CustomEvent("swiperInit", {}));
      },
    },
    zoom: true,
    breakpoints: {
      480: {
        slidesPerView: "auto",
        spaceBetween: 0,
        slidesPerGroup: 1,
        zoom: true, // Disable zoom on mobile devices (<= 480px)
      },
      768: {
        slidesPerView: "auto",
        spaceBetween: 0,
        slidesPerGroup: 1,
        zoom: true, // Disable zoom on tablets (<= 768px)
      },
      992: {
        slidesPerView: 1,
        spaceBetween: 0,
        slidesPerGroup: 1,
        zoom: { maxRatio: 2, minRatio: 1, toggle: true }, // Enable zoom on larger screens (>= 992px)
      },
    },
  });

  imageSwiperElement.addEventListener("click", () => {
    if (!isZoomedIn) {
      imageSwiper.zoom.in();
      isZoomedIn = true;
    } else {
      imageSwiper.zoom.out();
      isZoomedIn = false;
    }
  });

  // Add slide change event listener to reset zoom state
  imageSwiper.on("slideChange", function () {
    if (isZoomedIn) {
      imageSwiper.zoom.out();
      isZoomedIn = false;
    }
  });

  var thumbnailImages = document.querySelectorAll(
    ".product-img-slider_thumbnail"
  );

  // Add click event listeners to thumbnail images
  thumbnailImages.forEach(function (thumbnail, index) {
    thumbnail.addEventListener("click", function () {
      goToSlide(index); // Call goToSlide function with index when thumbnail is clicked
    });
  });

  function goToSlide(index) {
    imageSwiper.slideTo(index);
    updateActiveThumbnail(index);
  }

  // Function to update active thumbnail
  function updateActiveThumbnail(index) {
    var thumbnails = document.querySelectorAll(".product-img-slider_thumbnail");
    thumbnails.forEach(function (thumb, i) {
      thumb.classList.remove("is--active"); // Remove active class from all thumbnails
      if (i === index) {
        thumb.classList.add("is--active"); // Add active class to the clicked thumbnail
      }
    });
  }

  // Update active thumbnail when slide changes
  imageSwiper.on("slideChange", function () {
    updateActiveThumbnail(imageSwiper.realIndex); // Update active thumbnail
  });
}

// Ingredients swipers

let ingredientsSwipers = document.querySelectorAll("[swiper='ingredients']");

ingredientsSwipers.forEach((el) => {
  let swiperElement = el.querySelector(".swiper");

  const nextButton = el.querySelector("[swiper='next']");
  const prevButton = el.querySelector("[swiper='prev']");

  var swiper = new Swiper(swiperElement, {
    speed: 250,
    slidesPerView: "auto",
    spaceBetween: 12,
    loop: false,
    navigation: {
      nextEl: nextButton,
      prevEl: prevButton,
      disabledClass: "u-opacity-30", // Class to add when button is disabled
    },
    centeredSlides: false,
    mousewheel: { forceToAxis: true },
    breakpoints: {
      480: { slidesPerView: "auto", spaceBetween: 12, slidesPerGroup: 1 },
      768: { slidesPerView: 4, spaceBetween: 12, slidesPerGroup: 1 },
      992: {
        slidesPerView: 3.5,
        spaceBetween: 12,
        slidesPerGroup: 1,
      },
    },
    // on: {
    //   slideChange: function () {
    //     // Pause all videos when slide changes

    //     const allVideos = el.querySelectorAll('.swiper-slide video');
    //     allVideos.forEach((video) => {
    //       video.autoplay = true;
    //       video.muted = true;
    //       video.playsInline = true;
    //       video.loop = true;
    //     });

    //     allVideos.forEach((video) => {
    //       video.pause();
    //       video.currentTime = 0; // Reset video to start
    //     });

    //     // Play video in the active slide
    //     const activeSlide = swiper.slides[swiper.activeIndex];
    //     const activeVideo = activeSlide.querySelector('video');
    //     if (activeVideo) {
    //       activeVideo.play();
    //     }
    //   }
    // }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  let videoSlides = document.querySelectorAll("[application-slide]");
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          videoSlides.forEach((el) => {
            const video = el.querySelector("video");
          });
        }
      });
    },
    {
      threshold: 0.3,
    }
  );

  const observationFlag = document.querySelector(
    ".application-instructions-observation-flag"
  );
  observationFlag && observer.observe(observationFlag);
  videoSlides.forEach((el, index) => {
    // onclick play / pause
    el.addEventListener("mouseover", function () {
      const video = el.querySelector("video");
      video.play();
    });

    el.addEventListener("click", function () {
      const video = el.querySelector("video");
        video.play();
    });

    el.addEventListener("mouseleave", function () {
      const video = el.querySelector("video");
      video.pause();
    });
  });
});

// Ingredients toggle

document.querySelectorAll("[dropdown-toggle]").forEach((button) => {
  button.addEventListener("click", function () {
    const toggleValue = button.getAttribute("dropdown-toggle");
    const targetElement = document.querySelector(
      `[dropdown-content="${toggleValue}"]`
    );

    if (targetElement) {
      targetElement.classList.toggle("is--active");
    }

    const plusElement = document.querySelector(
      `[dropdown-plus="${toggleValue}"]`
    );

    if (plusElement) {
      const currentRotation = gsap.getProperty(plusElement, "rotation");

      gsap.to(plusElement, {
        rotation: currentRotation === 90 ? 0 : 90,
        duration: 0.3,
        transformOrigin: "center center",
      });
    }
  });
});

document.querySelectorAll("[dropdown-content]").forEach((content) => {
  content.classList.remove("is--active");
});

document.querySelectorAll("[dropdown-toggle]").forEach((button) => {
  if (button.getAttribute("dropdown-toggle") === "full-list") return;
  button.click();
});

//sticky buy buttons control
const stickyBuyButton = document.querySelector(".sticky-buy-root");
const overlay = document.querySelector("[data-sticky-buttons-overlay]");
const refinedPurchase = !!document.querySelector('[data-cx-mobile-refinement]');
function showRefinedSticky(entry) {
  return !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
}
let flag = false;
const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (refinedPurchase ? !showRefinedSticky(entry) : entry.isIntersecting) {
        // translate stickybuybutton up
        stickyBuyButton?.classList.add("is--intersected");
        overlay?.classList.add("is--intersected");
        const dropdownTrigger = document.querySelector(".dropdown-trigger");
        overlay?.classList.remove("is--active");
        dropdownTrigger?.classList.remove("is--active");
      } else {
        // translate stickybuybutton down
        stickyBuyButton?.classList.remove("is--intersected");
        overlay?.classList.remove("is--intersected");
      }
    });
  },
  {
    threshold: 0.05,
  }
);

const attachObservers = () => {
  if (refinedPurchase) {
    observer.disconnect();
    const primary = document.querySelector('.product-form_atc-button .button');
    if (primary) observer.observe(primary);
    return;
  }
  if (window.innerWidth > 768) {
    observer.unobserve(document.querySelector(".sticky-observer"));
    observer.observe(document.querySelector("[data-sticky-buy-button]"));
  } else {
    observer.unobserve(document.querySelector("[data-sticky-buy-button]"));
    observer.observe(document.querySelector(".sticky-observer"));
  }
};

attachObservers();

window.addEventListener("resize", attachObservers);

const dropdownTrigger = document.querySelectorAll(".dropdown-trigger");
const variantInputs = document.querySelectorAll("[data-sticky-variant-item]");
overlay?.addEventListener("click", () => {
  overlay.classList.remove("is--active");
  dropdownTrigger.forEach(el => el.classList.remove("is--active"));
});

const openDropdown = (dropdownTrigger) => {
  dropdownTrigger.forEach((el) => {
    el?.addEventListener("click", () => {
      const variantSize = parseInt(el.getAttribute("data-variants-size"));
      if (variantSize <= 1) {
        return;
      }
      el.classList.toggle("is--active");
      overlay?.classList.toggle("is--active");
    });
  });
};

openDropdown(dropdownTrigger);

document.addEventListener("variant:changed", (event) => {
  const changedVariant = event.detail;
  switchVariant(changedVariant.title, changedVariant.id, dropdownTrigger);
});

// Full product HTML is required below (both size and subscription selectors).
// Preserve market path, alternate view, existing preview state and UTMs. Never
// synthesize preview_theme_id, and never request a hard-coded section fragment.
function productVariantUrl(href, id) {
  const url = new URL(href);
  url.searchParams.set('variant', id);
  url.searchParams.delete('selling_plan');
  url.searchParams.delete('section_id');
  url.searchParams.delete('sections');
  url.hash = '';
  return url;
}
let variantRequest = 0;
const switchVariant = (name, id, dropdownTrigger) => {
  const variantId = id;
  const requestId = ++variantRequest;
  const variantName = name;
  const displayVariant = document.querySelectorAll("[data-selected]");
  displayVariant.forEach((el) => {
    el.querySelector("[data-variant-title]").innerText = variantName;
  });
  const mainVariantInput = stickyBuyButton.closest("form").querySelector("input[name='id']");
  mainVariantInput.value = variantId;
  mainVariantInput.setAttribute('value', variantId);
  const url = productVariantUrl(window.location.href, variantId);
  window.history.pushState({}, "", url);
  dropdownTrigger.forEach((el) => {
    el.classList.add("is--loading");
  });

  // Handle subscription options immediately using existing variant data
  const subscriptionWidget = document.querySelector('.subscription-widget');
  if (subscriptionWidget) {
    const autoReplenishRadio = subscriptionWidget.querySelector('input[value="subscription"]');
    const oneTimeRadio = subscriptionWidget.querySelector('input[value="one-time"]');
    const sellingPlanDropdown = subscriptionWidget.querySelector('.selling-plan-dropdown');
    
    // Find the matched variant from our existing variants array
    const matchedVariant = variants.find((variant) => variant.id === parseInt(variantId));
    
    // Always select one-time purchase by default when changing variants
    if (oneTimeRadio) {
      oneTimeRadio.checked = true;
    }
    
    // Always hide the selling plan dropdown when changing variants
    if (sellingPlanDropdown) {
      const hasOptions = sellingPlanDropdown.querySelectorAll('.dropdown-option').length > 0;
      sellingPlanDropdown.style.display = hasOptions ? 'none' : 'none'; // default hidden, only show when needed
      const hiddenInput = sellingPlanDropdown.querySelector('input[name="selling_plan"]');
      if (hiddenInput) hiddenInput.value = '';
      const dropdownContent = sellingPlanDropdown.querySelector('.dropdown-content');
      if (dropdownContent) {
        dropdownContent.classList.remove('show');
      }
    }
    
    if (autoReplenishRadio) {
      const hasSellingPlans = matchedVariant && matchedVariant.selling_plan_allocations && matchedVariant.selling_plan_allocations.length > 0;
      
      if (!hasSellingPlans) {
        // Disable auto-replenish if variant has no selling plans
        autoReplenishRadio.disabled = true;
        autoReplenishRadio.checked = false;
      } else {
        // Enable auto-replenish if variant has selling plans
        // Do not let a new variant use the previous variant's plan IDs.
        autoReplenishRadio.disabled = true;
      }
    }
  }

  // Update prices immediately
  const matchedVariant = variants.find((variant) => variant.id === parseInt(variantId));
  addToCartButtons.forEach(button => button.classList.toggle('is--disabled', !matchedVariant.available || matchedVariant.price === 0));
  const stickyPrice = document.querySelectorAll("[data-sticky-price]");
  stickyPrice.forEach((el) => {
    el.innerText = formatMoney(matchedVariant.price, project.moneyFormat);
  });

  // Fetch new content in the background
  fetch(url.toString())
    .then((response) => {
      if (!response.ok) throw new Error('Variant content unavailable');
      return response.text();
    })
    .then((data) => {
      if (requestId !== variantRequest) return;
      const parser = new DOMParser();
      const html = parser.parseFromString(data, "text/html");
      const newVariantContent = html.querySelector(".dropdown-trigger");
      const defaultVariantContent = document.querySelector(".default-variant-selector");
      const newDefaultVariantSelector = html.querySelector(".default-variant-selector");
      if (!newDefaultVariantSelector || !newVariantContent) throw new Error('Incomplete variant HTML');
      defaultVariantContent.innerHTML = newDefaultVariantSelector.innerHTML;
      setupListeners();
      dropdownTrigger.forEach((el) => {
        el.innerHTML = newVariantContent.innerHTML;
        el.classList.remove("is--loading");
      });
      attachListeners();

      
      const subscriptionWidget = document.querySelector('.subscription-widget');
      if (subscriptionWidget) {
        const autoReplenishRadio = subscriptionWidget.querySelector('input[value="subscription"]');
        if (autoReplenishRadio) {
          const sellingPlanDropdown = subscriptionWidget.querySelector('.selling-plan-dropdown');
          const newSellingPlanDropdown = html.querySelector('.selling-plan-dropdown');
          if (newSellingPlanDropdown && sellingPlanDropdown) {
            sellingPlanDropdown.innerHTML = newSellingPlanDropdown.innerHTML;
          }
          autoReplenishRadio.disabled = !newSellingPlanDropdown?.querySelector('.dropdown-option');
        }
      }

      
      updateRadioDataAttributes(variantId);
      updateSubscriptionOptionPrices(variantId);

      
      const selectedPurchaseType = document.querySelector('input[name="purchase_type"]:checked');
      if (selectedPurchaseType && selectedPurchaseType.value === 'subscription') {
        // If subscription is selected, update price to selling plan price
        const autoReplenishRadio = document.getElementById('auto-replenish');
        if (autoReplenishRadio) {
          const price = autoReplenishRadio.getAttribute('data-auto-replenish-price');
          updatePrices(
            null,
            price,
            '', 
            price
          );
        }
      } else {
        const oneTimeRadio = document.getElementById('one-time-purchase');
        if (oneTimeRadio) {
          const price = oneTimeRadio.getAttribute('data-one-time-price');
          updatePrices(
            null,
            price,
            '', 
            price
          );
        }
      }
    })
    .catch(() => {
      // One-time purchase still uses the selected variant; leave subscription
      // disabled rather than exposing stale selling-plan IDs after a failure.
    })
    .finally(() => {
      if (requestId === variantRequest) dropdownTrigger.forEach(el => el.classList.remove('is--loading'));
    });

  updateRadioDataAttributes(variantId);
  updateSubscriptionOptionPrices(variantId);
};

const attachListeners = () => {
  const variantInputs = document.querySelectorAll("[data-sticky-variant-item]");
  const dropdownTrigger = document.querySelectorAll(".dropdown-trigger");
  variantInputs.forEach((button) => {
    button.addEventListener("click", () => {
      switchVariant(
        button.id,
        button.getAttribute("data-value"),
        dropdownTrigger
      );
    });
  });
};

attachListeners();

/// zoom cursor image slider

const imgageZoomContainer = document.querySelector(".product-img_comp");
const zoomElement = document.querySelector(".product-img_zoom");

imgageZoomContainer.addEventListener("mousemove", (e) => {

  const { left, top } = imgageZoomContainer.getBoundingClientRect();
  const x = e.clientX - left;
  const y = e.clientY - top;

  gsap.set(zoomElement, {
    x: x,
    y: y,
  });

  gsap.to(zoomElement, {
    opacity: 1,
    duration: 0.125,
  });
});

imgageZoomContainer.addEventListener("mouseleave", () => {
  gsap.to(zoomElement, {
    opacity: 0,
    duration: 0.125,
    onComplete: () => {
      gsap.set(zoomElement, {
        x: 0,
        y: 0,
      });
    },
  });
});


function handlePurchaseTypeChange(input) {
  const sellingPlanDropdown = document.querySelector('.selling-plan-dropdown');
  const variantId = document.querySelector('input[name="id"]').value;

  if (input.value === 'subscription') {
    if (sellingPlanDropdown) {
      sellingPlanDropdown.style.display = 'block';
      
      const firstOption = sellingPlanDropdown.querySelector('.dropdown-option');
      if (firstOption) {
        selectSellingPlan(firstOption, firstOption.textContent.trim());
      }
    }
  } else {
    if (sellingPlanDropdown) {
      sellingPlanDropdown.style.display = 'none';
      const hiddenInput = sellingPlanDropdown.querySelector('input[name="selling_plan"]');
      if (hiddenInput) hiddenInput.value = '';
    }
    // Always update prices to the current variant price
    const matchedVariant = variants.find((variant) => variant.id === parseInt(variantId));
    if (matchedVariant) {
      updatePrices(
        null,
        formatMoney(matchedVariant.price, project.moneyFormat),
        matchedVariant.compare_at_price ? formatMoney(matchedVariant.compare_at_price, project.moneyFormat) : '',
        formatMoney(matchedVariant.price, project.moneyFormat)
      );
    }
  }
}

function toggleSellingPlanDropdown(button) {
  const dropdownContent = button.nextElementSibling;
  dropdownContent.classList.toggle('show');
}


function selectSellingPlan(option, text) {
  const dropdown = option.closest('.selling-plan-dropdown');
  const hiddenInput = dropdown.querySelector('input[name="selling_plan"]');
  const dropdownButton = dropdown.querySelector('button');
  const sellingPlanId = option.dataset.sellingPlanId;
  

  hiddenInput.value = sellingPlanId;
  if (dropdownButton.querySelector('.dropdown-text')) {
    dropdownButton.querySelector('.dropdown-text').textContent = text;
  }
  

  const variantId = document.querySelector('input[name="id"]').value;
  updatePrices(
    null,
    option.dataset.price,
    option.dataset.compareAtPrice,
    option.dataset.priceWithoutTrailingZeros
  );
  

  dropdown.querySelector('.dropdown-content').classList.remove('show');

  updateSubscriptionOptionPrices(variantId);
}


function updatePrices(priceElement, price, compareAtPrice, priceWithoutTrailingZeros) {
  const priceElements = document.querySelectorAll('[data-sticky-price]');
  const compareAtPriceElements = document.querySelectorAll('#productCompareAtPrice');
  
  priceElements.forEach(element => {
    element.textContent = price;
  });
  
  compareAtPriceElements.forEach(element => {
    if (compareAtPrice && compareAtPrice !== price) {
      element.textContent = compareAtPrice;
      element.classList.remove('hide');
    } else {
      element.classList.add('hide');
    }
  });
}

// Get price data for variant or selling plan
function getPriceData(type, variantId, sellingPlanId) {
  if (type === 'variant') {
    return document.querySelector(`[data-variant-id="${variantId}"]`);
  } else if (type === 'selling_plan') {
    return document.querySelector(`[data-selling-plan-id="${sellingPlanId}"]`);
  }
  return null;
}

// Update URL with variant and selling plan
function updateUrl(variantId, sellingPlanId) {
  const url = new URL(window.location.href);
  url.searchParams.set('variant', variantId);
  
  if (sellingPlanId) {
    url.searchParams.set('selling_plan', sellingPlanId);
  } else {
    url.searchParams.delete('selling_plan');
  }
  
  window.history.replaceState({}, '', url);
}

// Initialize subscription widget
document.addEventListener('DOMContentLoaded', function() {
  // Check URL parameters for subscription
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('selling_plan')) {
    const sellingPlanId = urlParams.get('selling_plan');
    const subscriptionRadio = document.querySelector('input[value="subscription"]');
    if (subscriptionRadio) {
      subscriptionRadio.checked = true;
      handlePurchaseTypeChange(subscriptionRadio);
      
      // Select the correct selling plan
      const sellingPlanOption = document.querySelector(`[data-selling-plan-id="${sellingPlanId}"]`);
      if (sellingPlanOption) {
        selectSellingPlan(sellingPlanOption, sellingPlanOption.textContent.trim());
      }
    }
  }
  
  // Close dropdowns when clicking outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.selling-plan-dropdown')) {
      document.querySelectorAll('.dropdown-content').forEach(dropdown => {
        dropdown.classList.remove('show');
      });
    }
  });

  const variantId = document.querySelector('input[name="id"]').value;
  updateRadioDataAttributes(variantId);
  updateSubscriptionOptionPrices(variantId);
});

function updateSubscriptionOptionPrices(variantId) {
  // Get the radio inputs
  const oneTimeRadio = document.getElementById('one-time-purchase');
  const autoReplenishRadio = document.getElementById('auto-replenish');

  // One-time price
  const oneTimePriceEl = document.getElementById('one-time-price');
  if (oneTimeRadio && oneTimePriceEl) {
    oneTimePriceEl.textContent = oneTimeRadio.getAttribute('data-one-time-price') || '';
  }

  // Auto-replenish price and discount
  const autoReplenishPriceEl = document.getElementById('auto-replenish-price');
  const autoReplenishDiscountEl = document.getElementById('auto-replenish-discount');
  if (autoReplenishRadio && autoReplenishPriceEl && autoReplenishDiscountEl) {
    autoReplenishPriceEl.textContent = autoReplenishRadio.getAttribute('data-auto-replenish-price') || '';
    autoReplenishDiscountEl.textContent = autoReplenishRadio.getAttribute('data-auto-replenish-discount') || '';
  }
}

function updateRadioDataAttributes(variantId) {
  const oneTimeRadio = document.getElementById('one-time-purchase');
  const autoReplenishRadio = document.getElementById('auto-replenish');
  const matchedVariant = variants.find((variant) => variant.id === parseInt(variantId));
  if (oneTimeRadio && matchedVariant) {
    oneTimeRadio.setAttribute('data-one-time-price', formatMoney(matchedVariant.price, project.moneyFormat));
  }
  if (autoReplenishRadio && matchedVariant && matchedVariant.selling_plan_allocations && matchedVariant.selling_plan_allocations.length > 0) {
    const firstPlan = matchedVariant.selling_plan_allocations[0];
    autoReplenishRadio.setAttribute('data-auto-replenish-price', formatMoney(firstPlan.price, project.moneyFormat));
    if (firstPlan.compare_at_price && firstPlan.compare_at_price > firstPlan.price) {
      const percent = Math.round(100 - (firstPlan.price / firstPlan.compare_at_price) * 100);
      autoReplenishRadio.setAttribute('data-auto-replenish-discount', `${percent}%`);
    } else {
      autoReplenishRadio.setAttribute('data-auto-replenish-discount', '');
    }
  } else if (autoReplenishRadio) {
    autoReplenishRadio.setAttribute('data-auto-replenish-price', '');
    autoReplenishRadio.setAttribute('data-auto-replenish-discount', '');
  }
}
